import Vue from "vue";

export default {
  getGeneralSettings({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/appraisals/settings/general", { params })
        .then(response => {
          commit("generalSettings", response.data[0]);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getAppraisalPeriods({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/appraisals/settings/general", { params })
        .then(response => {
          commit("appraisalPeriods", response.data[0].appraisalPeriods);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  addGeneralSettings(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/settings/general`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  updateGeneralSettings(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/appraisals/settings/general/${payload.id}`, payload.data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  deleteGeneralSettings(_, { id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/appraisals/settings/general/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Final Grade Settings
  getFinalGradeSettings({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/appraisals/settings/grades", { params })
        .then(response => {
          commit("finalGradeSettings", response.data);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  addFinalGrade(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/settings/grades`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  updateFinalGrade(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/appraisals/settings/grades`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  deleteFinalGradeSettings(_, { id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/appraisals/settings/grades/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Appraisal Setting
  handleSizeChangeAppraiserSettings({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAppraiserSettings");
  },
  handleCurrentChangeAppraiserSettings({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAppraiserSettings");
  },

  addAppraiserSettings(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/settings/appraisers`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  updateAppraiserSettings(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/appraisals/settings/appraisers/${payload.id}`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getAppraiserSettings({ commit, state }, payload = {}) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: payload.page || state.currentPage,
        perPage: payload.perPage || state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/appraisals/settings/appraisers", { params })
        .then(response => {
          commit("appraisalSettings", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getAppraiserApprovalSettings({ commit, state }, payload = {}) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: payload.page || state.currentPage,
        per_page: payload.perPage || state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/appraisals/settings/approver-settings", { params })
        .then(response => {
          commit("appraisalApprovalSettings", response.data.results);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Appraisal Group

  handleSizeChangeAppraiserGroup({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAppraisalGroups");
  },
  handleCurrentChangeAppraiserGroup({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAppraisalGroups");
  },

  createAppraisalGroup(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  sendOrInitiateAppraisalGroup({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      Vue.$http
        .post(`/hrm/appraisals/initiate`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  endAppraisal({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      Vue.$http
        .post(`/hrm/appraisals/end`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  updateAppraisalGroup(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/appraisals`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getAppraisalGroups({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(payload && payload),
      };

      Vue.$http
        .get("/hrm/appraisals", { params })
        .then(response => {
          commit("appraisalGroups", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getAppraisalGroupById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/appraisals/${id}`)
        .then(response => {
          commit("setSelectedRow", response.data);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Approval Appraisal
  handleSizeChangeAppraiserApproval({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAppraisalsApproval");
  },
  handleCurrentChangeAppraiserApproval({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAppraisalsApproval");
  },

  getAppraisalsApproval({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/appraisals/approvals", { params })
        .then(response => {
          commit("appraisalApproval", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  approveAppraisalsApproval(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/approve`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  rejectAppraisalsApproval(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/reject`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  archiveAppraisalGroup(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/appraisals/${payload.id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  archiveBulkAppraisalGroups(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/appraisals`, { data: { ids: payload.ids } })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getArchivedAppraisalGroups({ commit, state }, payload = {}) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(payload && payload),
      };

      Vue.$http
        .get("/hrm/appraisals/archives", { params })
        .then(response => {
          commit("archivedAppraisalGroups", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  restoreArchivedAppraisalGroups(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/appraisals/restore`, { ids: payload.ids })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  deleteArchivedAppraisalGroups(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/appraisals/archives`, { data: { ids: payload.ids } })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Appraisal's Appraisal

  handleSizeChangeMyAppraiser({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAppraisalsAppraisal");
  },
  handleCurrentChangeMyAppraiser({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAppraisalsAppraisal");
  },

  getAppraisalsAppraisal({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(payload && payload),
      };

      Vue.$http
        .get("/hrm/appraisals/appraiser-appraisables", { params })
        .then(response => {
          commit("appraisalsAppraisal", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getAppraisalsAppraisalById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/appraisals/fetch-appraisal/${id}`)
        .then(response => {
          commit("appraisalsAppraisalById", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  appraiserScoreGrading(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/appraiser-ratings`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
};
